import i18n from './../../../shared/i18n';

import BaseModel from "../../../core/components/input-widget/BaseModel";

export default class NoteForm extends BaseModel {
  uuid = null;
  customer_uuid = null;
  description = '';

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    description: 'required',
  };

  attributeLabels = {
    description: i18n.t('Description'),
  };

  getData() {
    return {
      uuid: this.uuid,
      customer_uuid: this.customer_uuid,
      description: this.description
    }
  }
}
